import React from 'react'
import "./Olaplex.css"

const OlaplexHead = () => {
  return (
    <div className='olaplexHeadContainer'>
       <h2>Olaplex</h2>
      <div className="olaplexUnderline"></div>
    </div>
  )
}

export default OlaplexHead
